// extracted by mini-css-extract-plugin
module.exports = {"ship-schedules":"ShipSchedules_ship-schedules__ao30p"};